/**
 * API'den gelen gerçek zamanlı veriyi işler
 * @param {Object} responseData - API yanıtı
 * @returns {Object} - İşlenmiş gerçek zamanlı veri
 */
export function processRealtimeData(responseData) {
  // API yanıtı yoksa boş nesne döndür
  if (!responseData) {
    return {
      totals: {
        activeUsers: 0,
        screenPageViews: 0,
        eventCount: 0,
      },
      byCountry: {},
      byDevice: {},
      timeline: {},
    };
  }

  // Veri iki seviye iç içe geçmiş olabilir
  const realtimeData = responseData.data || responseData;

  return {
    totals: realtimeData.totals || {
      activeUsers: 0,
      screenPageViews: 0,
      eventCount: 0,
    },
    byCountry: realtimeData.byCountry || {},
    byDevice: realtimeData.byDevice || {},
    timeline: realtimeData.timeline || {},
  };
}
